
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a/boat-rentals/search",
      function () {
        return require("private-next-pages/a/boat-rentals/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a/boat-rentals/search"])
      });
    }
  